<riv-icon *ngIf="icon" [name]="icon" [size]="16"></riv-icon>
<ng-content></ng-content>
